import { React, useEffect, useState } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox, Radio } from "antd";
import {
  HaberForm,
  RightDrawerContainer,
  DetailFields,
  ProductionSet,
} from "../../styledElements";
import { GlobalSet } from "../../pageStyled";
import {
  getOrdersByOrderNos,
  mergeOrders,
  mergeOrdersForSheetMatching
} from "../../../Services/orderServices";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import moment from "moment";
import { ModalPopup } from "../../../Components/Modal/modal";
import warning from "../../../Assets/Icons/warning.png";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { Collapse } from 'antd';
import { weightUnit, lengthUnit} from "../../../Utils/Constant/MeasurementUnitList";
const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const MergeDrawer = (props) => {  
  const { Panel } = Collapse;
  const [selectedGroup, setSelectedGroup] = useState();
  const [orderDetails, setOrderDetails] = useState();
  const [isVisibleModal, setIsVisibleModal] = useState(false);

  const [ordersData, setOrdersData] = useState([]);
  useEffect(async () => {
    setSelectedGroup('');
    if (props?.parent) {
      let parents = [];
      if (props.other_parents?.length) {
        parents = [...props.other_parents, props.parent];
      } else {
        parents = [props.parent];
      }
      try {
        const allOrdersData = await getOrdersByOrderNos(parents);
        const parentData = allOrdersData.data.filter(
          (item) => item.id === props.parent && item.state !== "cancel"
        );
        const otherData = allOrdersData.data.filter(
          (item) => item.id !== props.parent && item.state !== "cancel"
        );
        setOrdersData([...parentData, ...otherData]);
        if (parentData.length) {
          setSelectedGroup(props.parent);
        }
        setOrderDetails(props.orderDetails);
      } catch (error) {
        console.log(error);
      }
    }
  }, [props.parent]);

  const [form] = Form.useForm();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const onFinish = async (e = {}) => {
    setIsVisibleModal(true);
  };
  const modalConfirm = async () => {
    setIsVisibleModal(false);
    let selectedOrderData = ordersData?.filter((item) => item.id === selectedGroup);
    if(selectedOrderData[0]?.core_id && selectedOrderData[0]?.reel_od){
      try {
        const data = {
          parent: selectedGroup,
          child: orderDetails.orderno,
        };
        const response = await mergeOrders(data);
        props.toasterAction({
          error: false,
          msg: `Order ${orderDetails.orderno} is successfully merged`,
        });
        setSelectedGroup('');
        setOrderDetails();
        props.showToaster();
        props.rendering(true);
        props.handleMergeDrawerClose();
        //console.log(response);
      } catch (error) {
        console.log(error);
      }
    } else if(!selectedOrderData[0]?.core_id && !selectedOrderData[0]?.reel_od && selectedOrderData[0]?.type === "sheet"){
      try {
        const data = {
          parent: selectedGroup,
          child: orderDetails.orderno,
        };
        const response = await mergeOrdersForSheetMatching(data);
        props.toasterAction({
          error: false,
          msg: `Order ${orderDetails.orderno} is successfully merged`,
        });
        setSelectedGroup('');
        setOrderDetails();
        props.showToaster();
        props.rendering(true);
        props.handleMergeDrawerClose();
      } catch (error) {
        console.log(error);
      }
    }
  };
  const modalClose = () => {
    setIsVisibleModal(false);
  };
  const onFinishFailed = () => {
    scrollToTop();
  };
  const handleClose = () => {
    props.handleMergeDrawerClose();
    setSelectedGroup('');
    setOrderDetails();
  };
  const onChangeHandlerBox = (e, group) => {
    setSelectedGroup(group.id);
  };
  const onChangeCollpase = (key) => {
    // console.log(key);
  };

  return <RightDrawerSidebar
      title={`Merge Order ${props?.orderDetails?.orderno}`}
      visible={props.visible}
      onClose={handleClose}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          {/* Toasters */}

          {/* <AlertContainer color="blue" icon={alertBlue} msg="You can't modify a grade once added. A grade can only be deleted if there is no product created for that grade" /> */}
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                form={form}
              >
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order Details</h5>
                    <p style={{ marginBottom: "0px" }}>
                      Dimension :{" "}
                      {props?.orderDetails?.order_type == "reel"
                        ? props?.orderDetails?.width + " " + ( props?.orderDetails?.units && props?.orderDetails?.units?.width ? lengthUnit[props?.orderDetails.units.width]?.displayName?.toUpperCase() : "CM")
                        : props?.orderDetails?.width +
                          " X " +
                          props?.orderDetails?.length + " " + ( props?.orderDetails?.units && props?.orderDetails?.units?.width ? lengthUnit[props?.orderDetails.units.width]?.displayName?.toUpperCase() : "CM")}
                    </p>{" "}
                    <p style={{ marginBottom: "0px" }}>
                      Type : {props?.orderDetails?.type}{" "}
                      {props?.orderDetails?.grain
                        ? "(" + props?.orderDetails?.grain + " grain)"
                        : ""}
                    </p>
                    <p>Product Spec : {props?.orderDetails?.product_spec}</p>
                  </div>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Orders to merge</h5>
                    <p>Select the order to merge with</p>
                  </div>
                  <div className="prod-reelset">
                    {ordersData?.map((group) => {
                      return (
                        <ProductionSet>
                          <div className="prodset-header">
                            <GlobalSet>
                              <div className="checklist-address">
                                <Checkbox
                                  type="checkbox"
                                  checked={selectedGroup === group.id}
                                  onChange={(e) => onChangeHandlerBox(e, group)}
                                />
                                <div className="prodleft-header">
                                  <h4>Order {group.id}</h4>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      paddingLeft: "0px",
                                      color: "var(--color-text-title)",
                                      fontFamily: "var(--sf-pro-text)",
                                    }}
                                  >
                                    Delivery Date:{" "}
                                    {moment(group.delivery_date).format(
                                      "DD MMM YYYY"
                                    )}
                                  </p>
                                </div>
                              </div>
                            </GlobalSet>
                          </div>
                          <div className="prodset-body">
                            {group.quantity_type !== "reel_sheet" && <div className="prodset-dt">
                              <h5>Weight:</h5>
                              <p>{`${parseFloat(group.weight).toFixed(3)} ${" "} ${group?.units && group?.units?.weight ? capitalize(weightUnit[group.units.weight]?.displayName) : "T"}`}</p>
                            </div>}                            
                            {group.quantity_type === "reel_sheet" && <div className="prodset-dt">
                              <h5>Quantity:</h5>
                              <p>{`${group.no_of_reel_sheet} ${orderDetails?.type}s`}</p>
                            </div>}
                            <div className="prodset-dt">
                              <h5>Planned Weight:</h5>
                              <p>{`${parseFloat(group.planned_weight).toFixed(3)} ${" "} ${group?.units && group?.units?.planned_weight ? capitalize(weightUnit[group.units.planned_weight]?.displayName) : "T"}`}</p>
                            </div>
                            {!group.reel_od && !group.core_id && group.type === "sheet" ? (<div className="prodset-dt">
                                <Collapse 
                                onChange={onChangeCollpase}
                                expandIconPosition="right"
                                bordered={false}
                                style={{backgroundColor: "white", width:"500px", marginTop:"-16px", marginBottom:"-7px" , marginLeft:"-7px"}}>
                                <Panel
                                  header={"Tolerance -" + group.upper_tolerance + " to +"+ group.lower_tolerance +" %"}
                                  style={{ fontStyle: "italic" , marginLeft:"-12px",fontFamily: "var(--sf-pro-text)",  color: "#605e5c"}}>
                                  <Row
                                    style={{ marginTop: "3px" }}
                                    className="centerAlign  justifyCSBetween"
                                  >
                                    <Col span={8} className="blockBreak">
                                      <div className="titleWithText">
                                        <p style={{marginTop:"3px", fontStyle: "initial", fontSize: "13px", fontFamily: "var(--sf-pro-text)",
                                        color: "#6a6464", lineHeight: "20px", width:"102px",}}>Upper Tolerance </p>
                                      </div>
                                    </Col>
                                    <Col span={8} className="blockBreak">
                                      <div
                                        className="boxFormType"
                                        style={{ marginBottom: "0" }}
                                      >
                                        <Form.Item
                                          label=""
                                          name="upper_tolerance"
                                          rules={[
                                            {
                                              pattern: new RegExp(/^\d+(\.\d{0,5})?$/),
                                              message: "Only Numeric value is possible",
                                            },
                                            {
                                                required: true,
                                                message: "This field is required",
                                            },
                                          ]}
                                          className="dBlock"
                                          initialValue={group.upper_tolerance}
                                        >
                                          <Input
                                            placeholder=""
                                            style={{fontSize:"11px",height:"30px", marginLeft:"13px",color: "#6a6464"}}
                                            disabled={true}
                                          />
                                        </Form.Item>
                                        <span className="nonEditable" style={{fontize: "13px", top:"5px"}}>%</span>
                                      </div>
                                    </Col>
                                    <Col span={8} className="blockBreak">
                                      <Col span={8} className="blockBreak" style={{maxWidth:"45%", marginLeft:"15px"}}>
                                        <div className="titleWithText">
                                          <p style={{fontSize: "13px", fontFamily: "var(--sf-pro-text)",
                                          color: "#6a6464", lineHeight: "20px",marginLeft:"8px",
                                            marginTop:"4px",fontStyle: "initial", width:"104px"}}>{group.calculated_upper_tolerance+ " "} {" "} {group?.units && group?.units?.calculated_upper_tolerance ? capitalize(weightUnit[group.units.calculated_upper_tolerance]?.displayName) : "T"}</p>
                                        </div>
                                      </Col>
                                    </Col>
                                  </Row>

                                  <Row
                                    style={{ marginTop: "-10px", marginBottom:"-30px" }}
                                    className="centerAlign  justifyCSBetween"
                                  >
                                    <Col span={8} className="blockBreak">
                                      <div className="titleWithText">
                                        <p style={{marginTop:"3px", fontStyle: "initial", fontSize: "13px", fontFamily: "var(--sf-pro-text)",
                                        color: "#6a6464", lineHeight: "20px", width:"102px",}}>Lower Tolerance </p>
                                      </div>
                                    </Col>
                                    <Col span={8} className="blockBreak">
                                      <div
                                        className="boxFormType"
                                        style={{ marginBottom: "0" }}
                                      >
                                        <Form.Item
                                          label=""
                                          name="lower_tolerance"
                                          rules={[
                                            {
                                              pattern: new RegExp(/^\d+(\.\d{0,5})?$/),
                                              message: "Only Numeric value is possible",
                                            },
                                            {
                                                required: true,
                                                message: "This field is required",
                                            },
                                          ]}
                                          className="dBlock"
                                          initialValue={group.lower_tolerance}
                                        >
                                          <Input
                                            placeholder=""
                                            style={{fontSize:"11px",height:"30px", marginLeft:"13px",color: "#6a6464"}}
                                            disabled={true}
                                          />
                                        </Form.Item>
                                        <span className="nonEditable" style={{fontize: "13px", top:"5px"}}>%</span>
                                      </div>
                                    </Col>
                                    <Col span={8} className="blockBreak">
                                      <Col span={8} className="blockBreak" style={{maxWidth:"45%", marginLeft:"15px"}}>
                                        <div className="titleWithText">
                                          <p style={{fontSize: "13px", fontFamily: "var(--sf-pro-text)",
                                          color: "#6a6464", lineHeight: "20px",marginLeft:"8px",
                                            marginTop:"4px",fontStyle: "initial", width:"104px"}}>{group.calculated_lower_tolerance+ " "} {" "} {group?.units && group?.units?.calculated_lower_tolerance ? capitalize(weightUnit[group.units.calculated_lower_tolerance]?.displayName) : "T"}</p>
                                        </div>
                                      </Col>
                                    </Col>
                                  </Row>

                                </Panel>
                              </Collapse>
                              </div>) : (null)}
                            {group.reel_od && group.core_id && group.type === "sheet" ? (<div className="prodset-dt">
                              <h5>Reel OD:</h5>
                              <p>{`${group.reel_od} ${" "} ${group.units && group.units.reel_od ? lengthUnit[group.units.reel_od]?.displayName?.toUpperCase() : "CM"}`}</p>
                              <h5>Code OD:</h5>
                              <p>{`${group.core_id} ${" "} ${group.units && group.units.core_id ? lengthUnit[group.units.core_id]?.displayName?.toUpperCase() : "CM"}`}</p>
                            </div>) : (null)}                            
                          </div>
                        </ProductionSet>
                      );
                    })}
                  </div>
                </div>
                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      disabled={!selectedGroup}
                      htmlType="submit"
                      className="themeBtn"
                    >
                      <span
                        style={{
                          color: !selectedGroup ? "#A19F9D" : "#ffffff",
                        }}
                      >
                        Merge Order
                      </span>
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      onClick={handleClose}
                      key="3"
                      className="textTypeBtn"
                    >
                      Cancel changes
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
      <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Merge Order ?</span>
          <p>
            The order will be merged into the selected order and parameters of
            selected order will be applicable to the order. Are you sure you
            want to continue ?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
    </RightDrawerSidebar>
  // );
};

export default MergeDrawer;
